import './index-metric-docs.style.scss'

class indexMetricDocsController {

}

export default indexMetricDocsController;



// WEBPACK FOOTER //
// ./ui/src/components/index-metric-docs/index-metric-docs.controller.js